module.exports = __webpack_public_path__ + "img/poker-table.38fc7993.png";